import { GET, POST, PUT } from "./common/http";
import { BASE_URL } from "./common/const";

 
 
export const GetColourList = (params: any) =>
  GET(`${BASE_URL}/colour/list?` + params, null); 
                          